import {nextTick} from 'vue';
import shared from '../shared';
import {modal} from './modals/modals';
import _u from '../shared/utils';
import {store} from '../store/global-store';
import {formValidationMixin} from './mixins/component-mixins';
import {defineRule, Field, Form} from 'vee-validate';
import {min, regex, required} from '@vee-validate/rules';
import axios from 'axios';

defineRule('required', required);
defineRule('regex', regex);
defineRule('min', min);

const loginControl = {
    data() {
        return {
            loginMode: false,
            returnUrl: null,
            registrationTrigger: null,
            rememberMe: true,
            invitationId: null,
            password: null,
            isAgent: false,
            referencedUserEmail: null,
            enteredEmail: null,
            // true when login in modal
            // false for static pages - Login and Register
            isNeedToUpdateReturnUrl: true,
            isValidationVisible: false,
            submitting: false,
            authErrors: null,
        };
    },
    components: {
        VeeValidationFormContext: Form,
        ValidationField: Field,
    },
    computed: {
        validationModel() {
            return this.referencedUserEmail || {};
        },
        authErrorKeys() {
            return Object.keys(this.authErrors);
        },
        errorVisibility() {
            return this.authErrors;
        },
        userEmail() {
            return this.referencedUserEmail ? this.referencedUserEmail : this.enteredEmail;
        },
    },
    methods: {
        startFormSubmit() {
            this.submitting = true;
        },

        stopFormSubmit() {
            this.submitting = false;
        },

        switchMode() {
            this.loginMode = !this.loginMode;
            this.isValidationVisible = false;
            this.clearErrorState();
        },
        showValidation() {
            this.isValidationVisible = true;
        },
        beforeSubmit() {
            this.startFormSubmit();
            this.showValidation();
        },
        async _validate() {
            const validator = this.$refs.validator;
            const result = await validator.validate();

            return result.valid;
        },
        async submitForm() {
            this.beforeSubmit();

            if (await this._validate()) {
                this.clearErrorState();
                this._updateReturnUrl(this.$refs.form);
                this._deleteReferencedUserData();
                await this.sendDataAction();
            } else {
                this._handleSubmitError();
                this.stopFormSubmit();
            }
        },
        clearErrorState() {
            this.authErrors = null;
        },

        getFormRequestConfig() {
            const loginAntiforgeryTokenIndex = 7;
            const antiforgeryToken = this.$refs.form[loginAntiforgeryTokenIndex]?._value;
            return _u.createFormRequestConfig(antiforgeryToken);
        },
        async sendDataAction() {
            const requestConfig = this.getFormRequestConfig();
            const authForm = this.$refs.form;

            try {
                const response = await axios.post(authForm.action, authForm, requestConfig);

                this.handleSuccessResult(response);
            } catch (error) {
                this.handleErrorResult(error);
            }

            this.afterRequestSendingActions();
        },
        handleSuccessResult(response) {
            this.stopFormSubmit();
            if (response && response.status === 200) {
                if (response.data?.redirectUrl) {
                    const currentUrl = window.location.href.replace(window.location.origin, '');

                    if (currentUrl === response.data?.redirectUrl) {
                        window.location.reload();
                    } else {
                        window.location.href = response.data?.redirectUrl;
                    }
                }
            }
        },
        handleErrorResult(error) {
            this.stopFormSubmit();
            this.authErrors = error.response?.data?.errors;

            if (error.response.data?.email) {
                this.enteredEmail = error.response.data?.email;
            }
        },
        afterRequestSendingActions() {
        },
        async forceSubmitForm() {
            await this.sendDataAction();
        },
        submitSocialForm(formId) {
            const form = this.$refs[formId];
            if (form) {
                this.startFormSubmit(true);
                this._updateReturnUrl(form);
                this._deleteReferencedUserData();

                form.submit();
            }
        },
        _subscribeModeSwitch() {
            store.subscribe((mutation) => {
                if (mutation.type === 'loginModeSwitch') {
                    this.switchMode();
                }
            });
        },
        _setReferencedUserData() {
            nextTick(() => {
                this.invitationId = localStorage.getItem('invitationId');
                this.referencedUserEmail = localStorage.getItem('referencedUserEmail');
            });
        },
        _deleteReferencedUserData() {
            localStorage.removeItem('invitationId');
            localStorage.removeItem('referencedUserEmail');
        },
        _updateReturnUrl(form) {
            if (this.isNeedToUpdateReturnUrl) {
                const currentUrl = _u.getCurrentUrl();
                const homeUrl = '/';

                if (!this.returnUrl && !form.action.includes(currentUrl)) {
                    this.returnUrl = currentUrl;
                }

                // form action always includes / (slash)onCompleteCode
                // so if currentUrl is home url we should also assign it to returnUrl
                if (!this.returnUrl && currentUrl === homeUrl) {
                    this.returnUrl = currentUrl;
                }

                if (this.returnUrl && !form.action.includes('returnUrl')) {
                    form.action = _u.addQueryParamForUrl(form.action, 'returnUrl', this.returnUrl);
                }
            }
        },
        _subscribeChangePreselectRegistrationReasonStore() {
            store.subscribe((mutation) => {
                if (mutation.type === 'changePreselectRegistrationReason' && mutation.payload) {
                    this.registrationTrigger = mutation.payload;
                }
            });
        },
        _handleSubmitError() {

        },
    },
    mounted() {
        this._subscribeModeSwitch();
        this._subscribeChangePreselectRegistrationReasonStore();
        this._setReferencedUserData();
        if (this.authErrors) {
            this.showValidation();
        }
    },
};

function initLoginComponents(app) {
    app.component('login-modal', {
        mixins: [modal, formValidationMixin, loginControl],
        template: '#login-modal',
        computed: {
            loginModalOpened: {
                get() {
                    return store.state.shared.loginModalOpened;
                },
                set(value) {
                    if (value === false) {
                        store.commit('closeLoginModal');
                    }
                },
            },
        },
        methods: {
            close() {
                this.loginModalOpened = false;
            },
        },
    });

    return {shared, loginControl};
}

export {
    initLoginComponents,
    loginControl,
};
